import React, { Component } from "react";

class Podcastfront extends Component {
  state = {
    latestposttitle: "searching...",
    firstpostcontent: "looking up..."
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div className="bsix">
        <h5>Podcast</h5>
        <br />
        <h1>
          <a href="http://djmcloud.com">djmcloud.com</a>
          /podcast
        </h1>
        <br />
        <a
          href="https://itunes.apple.com/us/podcast/podcast-djmcloud-64/id415807688?mt=2"
          className="haeck itunes"
        >
          Available on iTunes
        </a>
        <br /> <br />
        <p id="rss_link">
          <a
            href="http://feeds2.pacificpelican.us/djmblog"
            className="haeck rss"
          >
            Subscribe to RSS
          </a>
        </p>
        <br />
        <br />
      </div>
    );
  }
}

export default Podcastfront;



// WEBPACK FOOTER //
// ./src/podcastfront.js